import React from 'react'
import TechFilter from './TechFilter'
import TechCards from './TechCards'

export default function Technologies() {
  return (
    <section className='technologies'>
      <div className='container'>
        <h2>Technology Stack</h2>
        <TechFilter />
        <TechCards />
      </div>
    </section>
  )
}
